<template>
	<div>
		<div id="header">
			<router-link tag="div" :to="{name:'vip',query:{is:'1'}}" id="back-div">
				<img src="../../static/img/back.png" alt="">
			</router-link>
			<div id="tit-div">上传</div>
			<div id="kong-div"> </div>
		</div>
		<div id="nav">
			<div>
				<!-- <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> -->
			</div>
		</div>
		<div style="padding:.1rem .16rem;">
			<input id="upload_file" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange($event)" />
			<div class="image-item space" @click="showActionSheet()">
				<div class="image-up"></div>
			</div>

			<div class="upload_warp">
				<div class="upload_warp_img">
					<div class="upload_warp_img_div" v-for="(item,index) in imgList">
						<div class="upload_warp_img_div_top">
							<img src="../../static/img/x.png" class="upload_warp_img_div_del" @click="fileDel(index)">
						</div>
						<img :src="item.file.src" style="display: inline-block;">
					</div>
					<div class="upload_warp_left" id="upload_warp_left" @click="fileClick()" v-if="this.imgList.length < 1">
                        +
					</div>
				</div>

			</div>

			<div class="upload_warp_text">
				<span>{{imgList.length}}张图片，{{bytesToSize(this.size)}}</span>
			</div>
			<div id="login1" @click="ipd"  v-if="this.imgList.length < 1">
                上传
            </div>
            <div id="login" @click="login" v-if="this.imgList.length > 0">
                上传
            </div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "Upload",
		data() {
			return {
				imgList: [],
				datas: new FormData(),
				files: 0,
				size: 0
			}
		},
		methods: {
			//调用相册&相机
			fileClick() {
				$('#upload_file').click();
			},
			//调用手机摄像头并拍照
			getImage() {
				let cmr = plus.camera.getCamera();
				cmr.captureImage(function(p) {
					plus.io.resolveLocalFileSystemURL(p, function(entry) {
						compressImage(entry.toLocalURL(), entry.name);
					}, function(e) {
						plus.nativeUI.toast("读取拍照文件错误：" + e.message);
					});
				}, function(e) {}, {
					filter: 'image'
				});
			},
			//从相册选择照片
			galleryImgs() {
				plus.gallery.pick(function(e) {
					let name = e.substr(e.lastIndexOf('/') + 1);
					compressImage(e, name);
				}, function(e) {}, {
					filter: "image"
				});
			},
			//点击事件，弹出选择摄像头和相册的选项
			showActionSheet() {
				let bts = [{
					title: "拍照"
				}, {
					title: "从相册选择"
				}];
				plus.nativeUI.actionSheet({
						cancel: "取消",
						buttons: bts
					},
					function(e) {
						if(e.index == 1) {
							this.getImage();
						} else if(e.index == 2) {
							this.galleryImgs();
						}
					}
				);
			},
			fileChange(el) {
				this.files = $("#upload_file").get(0).files;
                // console.log(this.files.length);
				for(let i = 0; i < this.files.length; i++) {
					this.datas.append("file", this.files[i]);
				}
				this.show1 = false;
				// console.log(typeof this.files);
				// console.log(this.files);
				if(!el.target.files[0].size) return;
				this.fileList(el.target);
				el.target.value = ''
			},
			fileList(fileList) {
				let files = fileList.files;
				for(let i = 0; i < files.length; i++) {
					//判断是否为文件夹
					if(files[i].type != '') {
						this.fileAdd(files[i]);
					} else {
						//文件夹处理
						this.folders(fileList.items[i]);
					}
				}
			},
			//文件夹处理
			folders(files) {
				let _this = this;
				//判断是否为原生file
				if(files.kind) {
					files = files.webkitGetAsEntry();
				}
				files.createReader().readEntries(function(file) {
					for(let i = 0; i < file.length; i++) {
						if(file[i].isFile) {
							_this.foldersAdd(file[i]);
						} else {
							_this.folders(file[i]);
						}
					}
				})
			},
			fileAdd(file) {
				//总大小
				this.size = this.size + file.size;
				//判断是否为图片文件
				if(file.type.indexOf('image') == -1) {
					file.src = 'wenjian.png';
					this.imgList.push({
						file
					});
				} else {
					let reader = new FileReader();
					reader.vue = this;
					reader.readAsDataURL(file);
					reader.onload = function() {
						file.src = this.result;
						this.vue.imgList.push({
							file
						});
					}
				}
			},
			fileDel(index) {
				this.size = this.size - this.imgList[index].file.size; //总大小
				this.imgList.splice(index, 1);
			},
			bytesToSize(bytes) {
				if(bytes === 0) {
					return '0 B';
				}
				let k = 1000, // or 1024
					sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
					i = Math.floor(Math.log(bytes) / Math.log(k));
				return(bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
			},
			dragenter(el) {
				el.stopPropagation();
				el.preventDefault();
			},
			dragover(el) {
				el.stopPropagation();
				el.preventDefault();
			},
			drop(el) {
				el.stopPropagation();
				el.preventDefault();
				this.fileList(el.dataTransfer);
			},
			shows(et, tx) {
				this.strut = et;
				this.txt = tx;
			},
			handleClick() {
				this.$store.commit('add')
			},
			ipd:function(){
				this.$toast.center('请选择图片！');
			},
			login:function(){
				this.$loading('请稍后...');
				let self = this;
				setTimeout(function () {
					self.closeLoading()
				}, 2000)
			},
			closeLoading:function(){
				let that = this
				that.$loading.close();
				that.$toast.center('上传成功，待审核!');
				setTimeout(function(){
                    that.$router.push({name:'BeautyList',query:{is_log:1}});
                },2500)
			},
			loadAd:function(id){
                // alert(id);
                let e_b_ts_1= new Date().getTime();
                let ad = document.createElement("script");
                ad.src="https://api.qvpublish.com/imp.js?id="+id+"&ts="+e_b_ts_1+"&tp=async";
                ad.id="e_b_sc_"+id;
                ad.type="text/javascript";
                // let section = document.getElementById("feed_"+id);
                let section = document.getElementById("nav");
                if(section){
                    // alert(1);
                    section.appendChild(ad);
                    // section.setAttribute("id","banner"+id+"_showed");
				        }
      }
		},
		mounted:function(){
			let that = this;
			that.loadAd(113);

		}
	}
</script>
<style scoped>
	#header {
		padding: 0 .16rem;
		height: .52rem;
		background: #600473;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	#back-div {
		width: .3rem;
	}

	#back-div img {
		width: .1rem;
	}

	#tit-div {
		color: #fff;
	}

	#kong-div {
		height: .3rem;
		width: .3rem;
    }
    .upload_warp_left{
        width: 1rem;
        text-align: center;
        height: 1rem;
        line-height: 1rem;
        font-size: .2rem;
        border-radius: .04rem;
        border: 1px solid #aaa;
        background: #fff;
    }
    .upload_warp_img_div{
        /* width: 1rem; */
    }
    .upload_warp_img_div img{
        width: 100%;
        height: 100%;
    }
    .upload_warp_img_div_top>img{
        width: 4%;
    }
    .upload_warp_text{
        font-size: .13rem;
    }
    #login{
		width: 1.6rem;
		height: .32rem;
		text-align: center;
		margin: .4rem auto;
		line-height: .32rem;
		color: #fff;
		background: #600473;
		border-radius:.04rem;
		font-size: .13rem
	}
	#login1{
		width: 1.6rem;
		height: .32rem;
		text-align: center;
		margin: .4rem auto;
		line-height: .32rem;
		color: #fff;
		background: #600473;
		border-radius:.04rem;
		font-size: .13rem
	}
</style>



// WEBPACK FOOTER //
// src/view/Upload.vue